// PageDescription: 실시간 의료 상담 글 작성 페이지
import { NextSeo } from 'next-seo';
import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import DefaultLayout from '@/components/layouts/DefaultLayout';
import QnaWriteMobileTemplate from '@/components/templates/mobile/communication/Qna/QnaWriteMobileTemplate';
import useQnaWriteMobileViewModel from '@/hooks/qna/useQnaWriteMobileViewModel';
import useAuthModal from '@/hooks/useAuthModal';
import { tokenState } from '@/recoil/atoms/common/auth';
import { CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';
import { isWebView } from '@/utils/mobile/RNPlugins';

const QnaWrite = ({ client }: CustomPageProps) => {
  const {setShowAuthModal, setTrackInfo} = useAuthModal(false, true);
  const token = useRecoilValue(tokenState);
  const qnaWriteMobileViewModel = useQnaWriteMobileViewModel();

  useEffect(() => {
    // eslint-disable-next-line security/detect-possible-timing-attacks
    if (token === null && isWebView()) {
      return;
    }

    if (!token) {
      setShowAuthModal(true);
      setTrackInfo({
        campaign: 'web_content_qna_write',
        content:'web_mid_mdl_main',
        buttonText:''
      });
    }
  }, [setShowAuthModal, token, client]);

  return (
    <>
      <NextSeo
        title="실시간 의료상담 - 닥터나우"
        description="24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요."
        canonical={`${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.QNA.WRITE.path}`}
        openGraph={{
          title: '실시간 의료상담 - 닥터나우',
          description:
            '24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요.',
          url: `${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.QNA.WRITE.path}`,
          images: [
            {
              url: `${process.env.NEXT_PUBLIC_QNA_OG_IMAGE}`,
              alt: 'Og Image Alt',
            },
          ],
        }}
      />
      <QnaWriteMobileTemplate
        client={client}
        qnaWriteMobileViewModel={qnaWriteMobileViewModel}
      />
    </>
  );
};

QnaWrite.Layout = DefaultLayout;

export default QnaWrite;
